/* eslint-disable react-js/forbid-component-props */
import {ContentEditable} from '@lexical/react/LexicalContentEditable';
import {i18n} from '@online-offer/i18n';
import {Box, Heading, VStack} from 'platform/foundation';
import {css} from 'styled-components';

import {isNilOrEmpty} from 'ramda-adjunct';

import {RichContentDisplay} from '@chat/ui';

import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';

export function DisclaimerText() {
  return (
    <ContentEditable
      css={css`
        color: ${({theme}) => theme.colors.text.tertiary};
        font-size: ${({theme}) => theme.fontSizes.text.xSmall};
        line-height: ${({theme}) => theme.lineHeights.text.xSmall};

        a {
          color: ${({theme}) => theme.colors.text.link};

          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      `}
    />
  );
}

export const Disclaimer = () => {
  const {disclaimer} = useGetOnlineOfferData();

  if (isNilOrEmpty(disclaimer)) {
    return null;
  }

  return (
    <Box paddingVertical={8}>
      <VStack spacing={4}>
        <Heading size={6} color="secondary">
          {i18n.t('disclaimer.heading')}
        </Heading>
        <RichContentDisplay
          ContentEditableComponent={<DisclaimerText />}
          markdown={disclaimer ?? ''}
        />
      </VStack>
    </Box>
  );
};
